import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  private renderer: Renderer2;

  constructor(@Inject(DOCUMENT) private document: Document,
              rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public injectGoogleAnalytics(): void {
    if (!environment.production) {
      return;
    }

    const googleAnalyticsId = environment?.googleAnalyticsId;
    if (!googleAnalyticsId) {
      return;
    }

    const scriptElement = this.document.createElement('script');
    scriptElement.async = true;
    scriptElement.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`;

    const scriptData = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${googleAnalyticsId}');
    `;

    const scriptElementData = this.document.createElement('script');
    scriptElementData.innerHTML = scriptData;

    this.renderer.appendChild(this.document.head, scriptElement);
    this.renderer.appendChild(this.document.head, scriptElementData);
  }
}
